<template>
  <div v-if="user" class="d-flex justify-content-between align-items-center user-item"
       :class="{'w-full mt-2':!serviceId}">
    <div class="d-flex align-items-center">
      <img class="round mr-3 img-fluid user-profile"
           :src="user.imagePath || require('../../../assets/images/avatar.png')">
      <div class="mr-2">
        <div><b>{{user.firstName +' '+ user.lastName}}</b></div>
        <span class="text-primary">{{ user.cellPhoneNumber}}</span>
        <p>
          <feather-icon v-if="user.homeLocationLatLong['latitude'] !== user.taskLocationLatLong['latitude']"
                        title="آدرس جدید" class="text-primary" icon="ZapIcon" svgClasses="w-4 h-4"/>

          {{user.taskLocationText}}
        </p>
      </div>

    </div>

    <div>
      <feather-icon v-if="serviceId" class="cursor-pointer ml-2" @click="deleteServiceMember" icon="XIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"/>
      <feather-icon v-else class="cursor-pointer ml-2" @click="deleteTaskMember" icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MemberCard",
    methods: {
      deleteServiceMember() {
        this.$store.dispatch('deleteServiceMember', {
          serviceId: this.serviceId,
          userId: this.user.id,
        })
      },
      deleteTaskMember() {
        this.$store.dispatch('deleteTaskMember', {
          taskId: this.$store.state.task.id,
          userId: this.user.id,
        })
      }
    },
    props: {
      user: [Object],
      serviceId: [Number]
    }
  }
</script>

<style>

  .user-profile {
    min-width: 35px;
    min-height: 35px;
    max-width: 35px;
    max-height: 35px;
  }

  .user-item {
    padding: 5px 10px;
    background-color: #f4f4f4;
    margin: 5px;
    width: calc(50% - 12px);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
  }

  .leaflet-top {
    z-index: 999 !important;
  }

  .leaflet-control-attribution.leaflet-control {
    display: none;
  }

  @media only screen and (max-width: 800px) {
    .user-item {
      width: 100%;
    }
  }
</style>
